import React from 'react';
import '../css/CityBarChart.css'; 

const CityBarChart = ({ data , loading }) => {
  const maxValue = data && Math.max(...data?.map(item => item?.totalCount));



  return (
    <div className="chart-container bg-light mt-3 ">
      <h3>Top Cities for customers</h3>
      <div className="chart">
        {loading && <>
        <div className='d-flex justify-content-center'>
<div className="loader">
  <svg viewBox="0 0 80 80">
    <circle r="32" cy="40" cx="40" id="test"></circle>
  </svg>
</div>

<div className="loader triangle">
  <svg viewBox="0 0 86 80">
    <polygon points="43 8 79 72 7 72"></polygon>
  </svg>
</div>

<div className="loader">
  <svg viewBox="0 0 80 80">
    <rect height="64" width="64" y="8" x="8"></rect>
  </svg>
</div>

        </div>
        </>}
        {data && data?.map((item, index) => (
          <div key={index} className="chart-row">
            <div className="city-name">{item?.name}</div>
                <div className="city-value">{item?.totalCount?.toLocaleString()}</div>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${(item?.totalCount / maxValue) * 100}%`,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CityBarChart;
